import styled from 'styled-components';
import { MQS } from '../constants/styles';

export const TwoColFormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    @media (min-width: ${MQS.mq3Min}) {
        flex-direction: row;
        margin-top: 50px;
        margin-bottom: 40px;
    }
`;

export const TwoColFormLeftElement = styled.div`
    flex: 1 1 100%;
    margin-top: 35px;
    margin-bottom: 35px;

    @media (min-width: ${MQS.mq3Min}) {
        flex: 1 1 48%;
        margin-right: 4%;
        margin-top: 0;
        margin-bottom: 0;
    }
`;
export const TwoColFormLeftElementLink = styled.div`
    flex: 1 1 50%;
    margin-top: 35px;
    margin-bottom: 35px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (min-width: ${MQS.mq3Min}) {
        flex: 1 1 48%;
        margin-right: 4%;
        margin-top: 0;
        margin-bottom: 0;
    }

    @media (max-width: ${MQS.mq3Min}) {
        margin-top: 0;
        margin-bottom: 0;
    }
`;
export const TwoColFormRightElement = styled.div`
    flex: 1 1 100%;
    margin-top: 35px;
    margin-bottom: 35px;

    @media (min-width: ${MQS.mq3Min}) {
        flex: 1 1 48%;
        margin-top: 0;
        margin-bottom: 0;
    }
    @media (max-width: ${MQS.mq3Min}) {
        margin-top: 0;
        margin-bottom: 0;
    }
`;

export const SingleFormElementWrapper = styled.div`
    margin-top: 50px;
    margin-bottom: 40px;
`;
